import styled from 'styled-components';

const TwoColStickyLayout = styled.section`
  position: sticky;
  top: ${props => props.theme.topBarHeight/10}em;
  width: ${props => props.width ? props.width : '50%'};
  height: calc(100vh - ${props => props.theme.topBarHeight/10}em);
  overflow: hidden;
  box-sizing: border-box;
`;

const TwoColContentLayout = styled.section`
  display: flex;
  box-sizing: border-box;
  width: ${props => props.width ? props.width : '50%'};
`;

const FlowStripeWrapper = styled.div`
  position: sticky;
  top: ${props => props.theme.topBarHeight/10}em;
  height: calc(100vh - ${props => props.theme.topBarHeight/10}em);
  width: ${props => props.theme.flowVerticalStripeW}px;
  box-sizing: border-box;
  border-right: 0.2em solid ${props => props.theme.highlightColor};
  border-left: 0.2em solid ${props => props.theme.highlightColor};
  z-index: 2;
  overflow: hidden;
  background-color: white;
`;

const TwoColScrollableContent = styled.article`
  width: ${props => props.width ? props.width : '50%'};
  height: calc(100vh - ${props => props.theme.topBarHeight/10}em);
  position: sticky;
  top: ${props => props.theme.topBarHeight/10}em;
  overflow-y: scroll;
  transition-property: width;
  transition-duration: 550ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  
  @media(max-width: ${props => props.theme.twoColToOneColLayout}px) {
    position: relative;
    width: 100%;
    top: 0;
    height: auto;
  }
`;

const TwoColScrollLayout = styled.article`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  
  @media (max-width: 1023px) {
    flex-direction: column;
    
    ${FlowStripeWrapper} {
      display: none;
    }
    
    ${TwoColStickyLayout} {
      position: relative;
      top: 0;
      height: auto;
    }
    
    ${TwoColStickyLayout}, ${TwoColContentLayout} {
      width: 100%;
    }
  }
`;

export {
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  TwoColScrollableContent,
  FlowStripeWrapper
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ui/TwoColScrollLayout.tsx